import React from 'react';
import { Link, useParams } from 'react-router-dom';
import journal from "./assets/document.png";
import verified from "./assets/verified.png";

const PaperDetailsIn = () => {
  const { id } = useParams();

  return (
    <div style={{ marginTop: "5.5rem" }}>
      <div className="container">
        <div className="row" style={{ marginLeft: "2px", marginRight: "2px" }}>
          <div className="col-6" style={{ padding: "5px" }}>
            <Link
              to={`/chapter-list/${id}`}
              className="card card-hover rounded-4 shadow-sm p-10"
            >
              <div className="card-body text-center">
                <img
                  className="mb-2"
                  src={verified}
                  alt="Pick Questions"
                  width={"50px"}
                />
                <h2 style={{ fontSize: "15px" }}>Pick Questions</h2>
              </div>
            </Link>
          </div>

          <div className="col-6" style={{ padding: "5px" }}>
            <Link
              to={`/download/${id}`}
              className="card card-hover rounded-4 shadow-sm"
            >
              <div className="card-body text-center">
                <img
                  className="mb-2"
                  src={journal}
                  alt="Download Paper"
                  width={"50px"}
                />
                <h2 style={{ fontSize: "15px" }}>Download Paper</h2>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaperDetailsIn;
